// components/Footer.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-4">
      <Container>
        <Row>
          <Col md={6}>
            <h5>Translational Bioinformatics Research Lab</h5>
            <p className="mb-1">Dr. Trupti Joshi - Senior Associate Dean for Informatics & Population Analytics</p>
            <p className="mb-1">Department of Biomedical Sciences</p>
            <p>Marshall University, Huntington</p>
          </Col>
          <Col md={6} className="text-md-end">
            <p className="mb-1">📧 joshitr@marshall.edu</p>
            <p className="mb-1">📍 Arthur Weisberg Family Applied Engineering Complex, Suite # 4101</p>
            <p className="mb-1">Joan C. Edwards School of Medicine</p>
            <p>Marshall University, Huntington, WV 25755</p>
          </Col>
        </Row>
        <hr className="my-3" />
        <Row>
          <Col className="text-center">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} Translational Bioinformatics Research Lab. All rights reserved.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;